import PrivacyIcon from './PrivacyIcon'

export default PrivacyIcon
